import {
    customValidation,
    validateConvertAmount,
    validateConvertDepositAmount,
} from "./validation-methods";
import {isTwoFieldsAmount} from "variables/is-two-fields-amount";
import { sendOpenSearchLogs } from "utils/helper-functions/send-open-search-logs.ts";
import store from "../../state/store";

export const validation = (data, required, type = "custom-method", changedField = null) => {
    return validationType(data, required, type, changedField);
};

const validationType = (data = {}, required, type, changedField = null) => {
    const state = store.getState();
    const {
        initTheme: { theme_editor_settings: { customization_settings: { layout, amount_field_type } = {} } = {} } = {},
        profileInfo: { base_currency } = {},
        resultOfPay
    } = state;
    const isAmountFirst = layout === 'amount-first';
    const retrySettings = resultOfPay?.transaction?.retry_settings ?? resultOfPay?.retry_settings;
    const isRetryPage = !!retrySettings;
    const isModernPanoramicRetry = layout === 'panoramic' && amount_field_type === 'modern' && isRetryPage;
    const {amount, totalCharge, currency, ...fields} = data;
    const isCurrencyConversion = base_currency !== currency && currency !== undefined && base_currency !== undefined;
    
    switch (type) {
        case "custom-method":
            return {
                ...customValidation(fields, required, changedField),
                ...validateConvertAmount(amount, currency, required),
            };
        case "amount": {
            if (isModernPanoramicRetry) {
                const baseSide = validateConvertAmount(amount, base_currency || currency);
                if (currency && base_currency && currency === base_currency) {
                    return {
                        amount: baseSide.amount || null,
                        currency: baseSide.currency || null,
                    };
                }
                const processingSide = validateConvertAmount(totalCharge, currency);
                return {
                    amount: baseSide.amount || processingSide.amount || processingSide.totalCharge || null,
                    currency: baseSide.currency || processingSide.currency || null,
                };
            }

            let amountToValidate = amount;
            let currencyForValidation = currency;

            if (isAmountFirst && isRetryPage && totalCharge !== null && totalCharge !== undefined && totalCharge !== '') {
                amountToValidate = totalCharge;
            }

            return {
                ...validateConvertAmount(amountToValidate, currencyForValidation),
            };
        }
        case "depositAmount":
            return {
                ...customValidation(fields, required),
                ...validateConvertDepositAmount(isCurrencyConversion ? totalCharge : amount, currency, required),
            };
        case "manual-bank-wire":
            return {
                ...customValidation(fields, required),
                ...(isTwoFieldsAmount ? 
                        validateConvertDepositAmount(isCurrencyConversion ? totalCharge : amount, currency || base_currency) : 
                        validateConvertAmount(isCurrencyConversion ? totalCharge : amount, currency || base_currency)),
            }
        
        default:
            const errorText = "function validation must have 'type' argument";

            sendOpenSearchLogs({
                event_group: "cashier_validation_type",
                error_data: errorText
            });

            console.error(errorText);
            return {};
    }
};
